import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createPickupLocation = (request) => {
    return vdkEmHappinessPortalApi.post(`/events/${request.eventId}/pickup-locations`, request);
};
const updatePickupLocation = (request) => {
    return vdkEmHappinessPortalApi.put(`/pickup-locations/${request.id}`, request);
};
const getAllPickupLocations = (request) => {
    return vdkEmHappinessPortalApi.post('/pickup-locations/get-all', request);
};
const getPickupLocationById = (id) => {
    return vdkEmHappinessPortalApi.get(`/pickup-locations/${id}`);
};
const deletePickupLocation = (id) => {
    return vdkEmHappinessPortalApi.delete(`/pickup-locations/${id}`);
};
const getPlacesAutocomplete = (request) => {
    return vdkEmHappinessPortalApi.get('/pickup-locations/places/autocomplete', { params: request });
};
const getPlaceDetails = (request) => {
    return vdkEmHappinessPortalApi.get('/pickup-locations/places/details', {
        params: request
    });
};
const getPickupLocationsNotPaginatedByEventId = (request) => {
    return vdkEmHappinessPortalApi.post('/pickup-locations/by-event', request);
};
const closePickupLocation = (request) => {
    return vdkEmHappinessPortalApi.post('/pickup-locations/close', request);
};
const checkAvailability = (request) => {
    return vdkEmHappinessPortalApi.post(`/pickup-locations/is-closed`, { PickupLocationId: request });
};
const getTransportDashboardSummary = (request) => {
    return vdkEmHappinessPortalApi.get('/pickup-locations/transport-dashboard/summary', { params: request });
};
const getTransportDashboardTrend = (request) => {
    return vdkEmHappinessPortalApi.get('/pickup-locations/transport-dashboard/trend', { params: request });
};
const getMapsKey = () => {
    return vdkEmHappinessPortalApi.get('/config/maps-key');
};
const pickupLocationAPI = {
    createPickupLocation,
    updatePickupLocation,
    getAllPickupLocations,
    getPickupLocationById,
    deletePickupLocation,
    getPlacesAutocomplete,
    getPlaceDetails,
    getPickupLocationsNotPaginatedByEventId,
    closePickupLocation,
    checkAvailability,
    getTransportDashboardSummary,
    getTransportDashboardTrend,
    getMapsKey
};
export default pickupLocationAPI;
